import { useState, useEffect, useRef, memo } from "react";
import axios from "axios";
import { TiTick } from "react-icons/ti";
import { HiUserAdd } from "react-icons/hi";
import { toast } from "react-hot-toast";
import { Navigate, useNavigate, useLocation } from "react-router-dom";
import backarrow from "../assets/icon/arrow-right.svg";
import { motion } from "framer-motion";
import DatePicker, { DateObject } from "react-multi-date-picker";
import persian from "react-date-object/calendars/persian";
import persian_fa from "react-date-object/locales/persian_fa";
import gregorian from "react-date-object/calendars/gregorian";
import gregorian_en from "react-date-object/locales/gregorian_en";
import {
  FaBook,
  FaBookOpen,
  FaRegListAlt,
  FaDatabase,
  FaUserGraduate,
  FaChalkboardTeacher,
  FaCalculator,
  FaChartLine,
  FaCoins,
  FaPenFancy,
  FaRegFileAlt,
  FaPencilAlt,
} from "react-icons/fa";

// پس‌ زمینه متحرک
const icons = [
  FaBook,
  FaBookOpen,
  FaRegListAlt,
  FaDatabase,
  FaUserGraduate,
  FaChalkboardTeacher,
  FaCalculator,
  FaChartLine,
  FaCoins,
  FaPenFancy,
  FaRegFileAlt,
  FaPencilAlt,
];

const staticBackgroundIcons = (() => {
  const rows = 5,
      cols = 11,
      arr = [];
  for (let i = 0; i < rows; i++)
    for (let j = 0; j < cols; j++) {
      const Icon = icons[Math.floor(Math.random() * icons.length)];
      arr.push({
        Icon,
        size: 18 + Math.random() * 20,
        top: (i / rows) * 100 + Math.random() * 5,
        left: (j / cols) * 100 + Math.random() * 5,
        duration: 12 + Math.random() * 10,
        opacity: 0.15 + Math.random() * 0.25,
        xOffset: Math.random() * 10 - 5,
        yOffset: Math.random() * 10 - 5,
      });
    }
  return arr;
})();

const AnimatedBackground = memo(() => (
    <div className="absolute inset-0 overflow-hidden pointer-events-none">
      {staticBackgroundIcons.map((item, i) => (
          <motion.div
              key={i}
              className="absolute text-white/50"
              style={{
                top: `${item.top}%`,
                left: `${item.left}%`,
                opacity: item.opacity,
              }}
              initial={{ scale: 0.5 }}
              animate={{
                x: [0, item.xOffset, 0],
                y: [0, item.yOffset, 0],
                scale: [0.5, 1, 0.5],
              }}
              transition={{
                duration: item.duration,
                repeat: Infinity,
                ease: "easeInOut",
              }}
          >
            <item.Icon size={item.size} />
          </motion.div>
      ))}
    </div>
));

const EditStudent = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const studentid = location.state?.studentid;
  const API_BASE = process.env.REACT_APP_API_URL;

  const [loading, setLoading] = useState(true);
  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [fatherName, setFatherName] = useState("");
  const [email, setEmail] = useState("");
  const [mobile, setMobile] = useState("");
  const [ContactNumber, setContactNumber] = useState("");
  const [National_Code, setNational_Code] = useState("");
  const [address, setAddress] = useState("");

  const [datevalue, setDateValue] = useState(null);
  const [sendDate, setSendDate] = useState("");

  const [choosefemalegender, setChooseFemalegender] = useState(false);
  const [choosemalegender, setChoosemalegender] = useState(false);

  const [uploadimage, setUploadimage] = useState("");
  const [showuploadicon, setShowuploadicon] = useState(true);
  const [apiimage, setApiimage] = useState("");
  const [imageid, setImageid] = useState("");
  const [uploadingImage, setUploadingImage] = useState(false);

  // دریافت اطلاعات دانشجو
  const getstudent = async () => {
    if (!studentid) return navigate("/Mainpage/StudentsInf");
    try {
      const res = await axios.get(
          `${API_BASE}/api/student/Get-Single-Student-By-Id/${studentid}`,
          {
            headers: { Authorization: localStorage.getItem("token") },
          }
      );

      const data = res.data.data.studentinf;
      setFirstName(data.firstName || "");
      setLastName(data.lastName || "");
      setFatherName(data.fatherName || "");
      setEmail(data.email || "");
      setMobile(data.mobile || "");
      setContactNumber(data.ContactNumber || "");
      setNational_Code(data.National_Code || "");
      setAddress(data.address || "");

      if (data.gender === "female") {
        setChooseFemalegender(true);
        setChoosemalegender(false);
      } else if (data.gender === "male") {
        setChoosemalegender(true);
        setChooseFemalegender(false);
      }

      if (data.birthDate) {
        const miladiDate = new DateObject(data.birthDate);
        const shamsiDate = miladiDate.convert(persian, persian_fa);
        setDateValue(shamsiDate);
        setSendDate(data.birthDate);
      }

      if (data.profile) {
        setApiimage(`${API_BASE}/${data.profile.fileName}`);
        setShowuploadicon(false);
      }

      setLoading(false);
    } catch (error) {
      toast.error(error?.response?.data?.message || "خطا در دریافت اطلاعات");
      setLoading(false);
    }
  };

  useEffect(() => {
    getstudent();
  }, [studentid]);

  // تابع فشرده‌سازی تصویر
  const compressImage = (file) => {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);

      reader.onload = (event) => {
        const img = new Image();
        img.src = event.target.result;

        img.onload = () => {
          const canvas = document.createElement('canvas');

          // ابعاد کوچک: 600px
          let maxDimension = 600;
          let width = img.width;
          let height = img.height;

          if (width > height) {
            if (width > maxDimension) {
              height = (height * maxDimension) / width;
              width = maxDimension;
            }
          } else {
            if (height > maxDimension) {
              width = (width * maxDimension) / height;
              height = maxDimension;
            }
          }

          canvas.width = width;
          canvas.height = height;

          const ctx = canvas.getContext('2d');
          ctx.drawImage(img, 0, 0, width, height);

          // کیفیت پایین: 0.6
          canvas.toBlob(
              (blob) => {
                if (!blob) {
                  reject(new Error('خطا در فشرده‌سازی'));
                  return;
                }

                const compressedFile = new File([blob], file.name.replace(/\.[^/.]+$/, '.jpg'), {
                  type: 'image/jpeg',
                  lastModified: Date.now(),
                });

                resolve(compressedFile);
              },
              'image/jpeg',
              0.6
          );
        };

        img.onerror = () => reject(new Error('خطا در بارگذاری تصویر'));
      };

      reader.onerror = () => reject(new Error('خطا در خواندن فایل'));
    });
  };

  // آپلود تصویر با فشرده‌سازی
  const handleuploadimage = async (e) => {
    const file = e.target.files[0];
    if (!file) return;

    if (!file.type.startsWith('image/')) {
      toast.error('لطفاً یک فایل تصویری انتخاب کنید');
      return;
    }

    setUploadingImage(true);
    setShowuploadicon(false);

    try {
      // فشرده‌سازی
      const compressedFile = await compressImage(file);

      const formdata = new FormData();
      formdata.append("file", compressedFile);

      const res = await axios.post(
          `${API_BASE}/api/files/admin/upload-file`,
          formdata,
          {
            headers: {
              Authorization: localStorage.getItem("token"),
            },
          }
      );

      toast.success("تصویر آپلود شد");
      setImageid(res.data.data.fileId);
      setUploadimage(URL.createObjectURL(compressedFile));
      setApiimage("");
    } catch (error) {
      toast.error(error?.response?.data?.message || "خطا در آپلود تصویر");
      setShowuploadicon(true);
    } finally {
      setUploadingImage(false);
    }
  };

  // تغییر تاریخ
  const handleDateChange = (date) => {
    if (!date) {
      setDateValue(null);
      setSendDate("");
      return;
    }

    setDateValue(date);

    try {
      // تبدیل به میلادی
      const gregorianDate = date.convert(gregorian, gregorian_en);
      const formattedDate = gregorianDate.format("YYYY-MM-DD");

      setSendDate(formattedDate);
    } catch (error) {
      toast.error('خطا در تبدیل تاریخ');
      setSendDate("");
    }
  };

  // ویرایش دانشجو
  const handleeditstudent = async () => {
    // Validation
    if (!firstName.trim()) {
      toast.error("نام الزامی است");
      return;
    }
    if (!lastName.trim()) {
      toast.error("نام خانوادگی الزامی است");
      return;
    }
    if (!choosefemalegender && !choosemalegender) {
      toast.error("لطفاً جنسیت را انتخاب کنید");
      return;
    }

    try {
      const payload = {
        firstName: firstName.trim(),
        lastName: lastName.trim(),
        gender: choosefemalegender ? "female" : "male",
      };

      // اضافه کردن فیلدهای اختیاری فقط اگر مقدار داشتند
      if (email.trim()) payload.email = email.trim();
      if (mobile.trim()) payload.mobile = mobile.trim();
      if (National_Code.trim()) payload.National_Code = National_Code.trim();
      if (address.trim()) payload.address = address.trim();
      if (ContactNumber.trim()) payload.ContactNumber = ContactNumber.trim();
      if (fatherName.trim()) payload.fatherName = fatherName.trim();

      // پردازش تاریخ - اگر تاریخ وجود داشت فقط بخش YYYY-MM-DD رو بفرست
      if (sendDate) {
        const dateOnly = sendDate.split('T')[0];
        payload.birthDate = dateOnly;
      }

      if (imageid) payload.imageid = imageid;

      const res = await axios.post(
          `${API_BASE}/api/student/Edit-Student/${studentid}`,
          payload,
          {
            headers: { Authorization: localStorage.getItem("token") },
          }
      );

      toast.success("دانشجو با موفقیت ویرایش شد");
      navigate("/Mainpage/StudentsInf");
    } catch (error) {
      if (error.response?.status === 400) {
        const errorData = error.response?.data;
        if (errorData?.message) {
          toast.error(errorData.message);
        } else if (typeof errorData === 'object') {
          // نمایش اولین خطای validation
          const firstError = Object.values(errorData)[0];
          toast.error(Array.isArray(firstError) ? firstError[0] : firstError);
        } else {
          toast.error("داده‌های ورودی نامعتبر است");
        }
      } else {
        toast.error(error?.response?.data?.message || "خطا در ویرایش دانشجو");
      }
    }
  };

  if (!localStorage.getItem("token")) return <Navigate to="/" />;

  return (
      <div className="relative min-h-screen w-full bg-gray-800 flex items-center justify-center py-12 px-4">
        <AnimatedBackground />

        <motion.div
            initial={{ opacity: 0, scale: 0.94 }}
            animate={{ opacity: 1, scale: 1 }}
            transition={{ duration: 0.5 }}
            className="bg-white/90 backdrop-blur-xl rounded-2xl shadow-2xl p-5 w-full max-w-2xl mx-auto border border-white/30"
        >
          {/* هدر */}
          <div className="flex items-center justify-between mb-5">
            <img
                src={backarrow}
                alt="back"
                className="w-8 h-8 cursor-pointer hover:scale-110 transition"
                onClick={() => navigate(-1)}
            />
            <h2 className="text-xl font-bold text-gray-800">ویرایش دانشجو</h2>
            <div className="w-8" />
          </div>

          {/* تصویر پروفایل */}
          <div className="flex justify-center my-5">
            <div
                onClick={() => !uploadingImage && document.querySelector("#openimage").click()}
                className={`relative w-24 h-24 rounded-full border-[3px] border-gray-700 overflow-hidden shadow-lg transition ${
                    uploadingImage ? 'cursor-wait opacity-70' : 'cursor-pointer hover:scale-105'
                }`}
            >
              <input
                  onChange={handleuploadimage}
                  type="file"
                  className="hidden"
                  accept="image/*"
                  id="openimage"
                  disabled={uploadingImage}
              />
              {showuploadicon ? (
                  <div className="w-full h-full flex items-center justify-center bg-gray-100">
                    {uploadingImage ? (
                        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-gray-600"></div>
                    ) : (
                        <HiUserAdd size={48} className="text-gray-600" />
                    )}
                  </div>
              ) : (
                  <>
                    <img
                        src={uploadimage || apiimage}
                        alt="student"
                        className="w-full h-full object-cover"
                    />
                    {uploadingImage && (
                        <div className="absolute inset-0 bg-black/50 flex items-center justify-center">
                          <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-white"></div>
                        </div>
                    )}
                  </>
              )}
            </div>
          </div>

          {loading ? (
              <div className="text-center py-10 text-gray-600 font-medium">
                در حال دریافت اطلاعات...
              </div>
          ) : (
              <div className="space-y-4 text-sm">
                {/* نام و نام خانوادگی */}
                <div className="grid grid-cols-2 gap-3">
                  <Input
                      value={firstName}
                      setValue={setFirstName}
                      placeholder="نام"
                  />
                  <Input
                      value={lastName}
                      setValue={setLastName}
                      placeholder="نام خانوادگی"
                  />
                </div>

                {/* نام پدر و ایمیل */}
                <div className="grid grid-cols-2 gap-3">
                  <Input
                      value={fatherName}
                      setValue={setFatherName}
                      placeholder="نام پدر"
                  />
                  <Input value={email} setValue={setEmail} placeholder="ایمیل" />
                </div>

                {/* موبایل و شماره تماس */}
                <div className="grid grid-cols-2 gap-3">
                  <Input
                      value={mobile}
                      setValue={setMobile}
                      placeholder="شماره همراه"
                      onlyNumbers
                      maxLength={11}
                  />
                  <Input
                      value={ContactNumber}
                      setValue={setContactNumber}
                      placeholder="شماره تماس"
                      onlyNumbers
                      maxLength={11}
                  />
                </div>

                {/* کد ملی و تاریخ تولد */}
                <div className="grid grid-cols-2 gap-3">
                  <Input
                      value={National_Code}
                      setValue={setNational_Code}
                      placeholder="کد ملی"
                      onlyNumbers
                      maxLength={10}
                  />
                  <DatePicker
                      value={datevalue}
                      onChange={handleDateChange}
                      calendar={persian}
                      locale={persian_fa}
                      format="YYYY/MM/DD"
                      placeholder="تاریخ تولد"
                      inputClass="w-full px-4 py-3 rounded-lg border-2 border-gray-400 focus:border-gray-700 outline-none text-gray-800 text-sm text-right bg-white/70"
                  />
                </div>

                {/* فیلد جنسیت */}
                <div className="space-y-3">
                  <p className="font-bold text-gray-800">جنسیت:</p>
                  <div className="grid grid-cols-2 gap-6">
                    <label className="flex items-center gap-3 cursor-pointer">
                      <div
                          className={`w-6 h-6 rounded-full border-2 flex items-center justify-center transition ${
                              choosefemalegender
                                  ? "border-gray-800 bg-gray-800"
                                  : "border-gray-400"
                          }`}
                          onClick={() => {
                            setChooseFemalegender(true);
                            setChoosemalegender(false);
                          }}
                      >
                        {choosefemalegender && (
                            <TiTick className="text-white" size={16} />
                        )}
                      </div>
                      <span className="text-gray-700">زن</span>
                    </label>

                    <label className="flex items-center gap-3 cursor-pointer">
                      <div
                          className={`w-6 h-6 rounded-full border-2 flex items-center justify-center transition ${
                              choosemalegender
                                  ? "border-gray-800 bg-gray-800"
                                  : "border-gray-400"
                          }`}
                          onClick={() => {
                            setChoosemalegender(true);
                            setChooseFemalegender(false);
                          }}
                      >
                        {choosemalegender && (
                            <TiTick className="text-white" size={16} />
                        )}
                      </div>
                      <span className="text-gray-700">مرد</span>
                    </label>
                  </div>
                </div>

                {/* آدرس */}
                <textarea
                    value={address}
                    onChange={(e) => setAddress(e.target.value)}
                    placeholder="آدرس..."
                    rows={3}
                    className="w-full p-3 rounded-lg border-2 border-gray-400 focus:border-gray-700 outline-none text-gray-800 font-medium resize-none bg-white/70"
                />

                {/* دکمه ذخیره */}
                <motion.button
                    whileHover={{ scale: 1.03 }}
                    whileTap={{ scale: 0.98 }}
                    onClick={handleeditstudent}
                    disabled={uploadingImage}
                    className={`w-full py-4 bg-gray-800 hover:bg-gray-900 text-white font-bold rounded-lg shadow-xl transition mt-6 ${
                        uploadingImage ? 'opacity-50 cursor-not-allowed' : ''
                    }`}
                >
                  {uploadingImage ? 'در حال آپلود...' : 'ذخیره تغییرات'}
                </motion.button>
              </div>
          )}
        </motion.div>
      </div>
  );
};

const Input = ({
                 value,
                 setValue,
                 placeholder,
                 maxLength,
                 onlyNumbers,
                 className = "",
               }) => (
    <input
        type="text"
        value={value}
        onChange={(e) => setValue(e.target.value)}
        placeholder={placeholder}
        maxLength={maxLength}
        onKeyDown={(e) =>
            onlyNumbers &&
            !/[0-9]|Backspace|Delete|ArrowLeft|ArrowRight|Tab/.test(e.key) &&
            e.preventDefault()
        }
        className={`w-full px-4 py-3 rounded-lg border-2 border-gray-400 focus:border-gray-700 outline-none text-gray-800 font-medium text-sm bg-white/70 transition ${className}`}
    />
);

export default EditStudent;